import { Address, Country } from '@commenda/prisma';
import { IAddress } from '@commenda/types';
import {
  postcodeValidator,
  postcodeValidatorExistsForCountry,
} from 'postcode-validator';

const validateEmail = (email: string): boolean => {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export enum AddressValidationErrors {
  INVALID_POSTAL_CODE = 'INVALID_POSTAL_CODE',
}

export function validateAddress(
  address:
    | Address
    | {
        addressLine1?: string;
        addressLine2?: string;
        addressLine3?: string;
        city?: string;
        country?: Country;
        state?: string;
        postalCode: string;
      }
    | IAddress
) {
  if (!address) return { result: false };

  const isValidLines =
    address?.addressLine1?.length && address.addressLine1.length > 0;

  const doesPostcodeValidatorExist = postcodeValidatorExistsForCountry(
    address.country
  );
  const isPostcodeValid = postcodeValidator(
    address.postalCode.trim(),
    address.country
  );

  const isValidPostalCode =
    address?.postalCode?.trim()?.length &&
    address.postalCode.trim().length > 0 &&
    (!doesPostcodeValidatorExist || isPostcodeValid);
  const isValidCity = address?.city?.length && address.city.length > 0;
  // validating country length === 2 because it's an isoCode (IN) and not (India)
  const isValidCountry = address?.country?.length === 2;
  const isValidState = address?.state?.length && address.state.length > 0;
  return {
    result:
      isValidCity &&
      isValidCountry &&
      isValidPostalCode &&
      isValidLines &&
      isValidState,
    isValidCity,
    isValidState,
    isValidCountry,
    isValidPostalCode,
    isValidLines,
    error:
      doesPostcodeValidatorExist && !isPostcodeValid
        ? AddressValidationErrors.INVALID_POSTAL_CODE
        : null,
  };
}

export { validateEmail };
